import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Blogs from "@/pages/Blogs";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminServices from "@/pages/admin/AdminServices";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminIndustries from "@/pages/admin/AdminIndustries";
import AdminPageSections from "@/pages/admin/AdminPageSections";
import AdminPageEditor from "@/pages/admin/AdminPageEditor";
import AdminSmtp from "@/pages/admin/AdminSmtp";
import AdminGuard from "@/components/admin/AdminGuard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Services />} />
            <Route path="industries" element={<Industries />} />
            <Route path="blogs" element={<Blogs />} />
            <Route path="contact" element={<Contact />} />
          </Route>

          {/* Admin */}
          <Route path="/ngxp-admin" element={<AdminLogin />} />
          <Route path="/ngxp-admin" element={<AdminGuard />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="industries" element={<AdminIndustries />} />
            <Route path="pages/:page" element={<AdminPageSections />} />
            <Route path="pages/:page/:key" element={<AdminPageEditor />} />
            <Route path="smtp" element={<AdminSmtp />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
